// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"58ac5270","865":"4e7dbe4a"}[chunkId] + ".chunk.js";
};